import { reqDelivery } from "../request/bsplatform/carrier/delivery/method/post.js";
async function reviseProductsDeliveryMethod(arg) {
  const { destinationRegion, originRegion } = arg;
  const deliveryList = await reqDelivery({ destinationRegion, originRegion });
  const checkDeliveryList = getCheckDeliveryList(deliveryList);
  return arg.products.map((product) => {
    if (product.paramConfig && product.paramConfig.deliveryMethod && !checkDeliveryList.includes(product.paramConfig.deliveryMethod)) {
      product.paramConfig.deliveryMethod = "";
    }
    return product;
  });
}
function getCheckDeliveryList(deliveryList) {
  return [...deliveryList, "\u4E00\u4EF6\u4EE3\u53D1-\u914D\u9001\u81F3\u7ECF\u9500\u5546", "\u4E00\u4EF6\u4EE3\u53D1-\u914D\u9001\u81F3\u7EC8\u7AEF"];
}
async function checkProductsDeliveryMethod(arg) {
  const { destinationRegion, originRegion } = arg;
  const sliceDestinationRegion = destinationRegion.slice(0, 6) + "000000";
  const deliveryList = await reqDelivery({ destinationRegion: sliceDestinationRegion, originRegion });
  const checkDeliveryList = getCheckDeliveryList(deliveryList);
  return arg.products.some((p) => {
    return p.paramConfig && p.paramConfig.deliveryMethod && !checkDeliveryList.includes(p.paramConfig.deliveryMethod);
  });
}
export { checkProductsDeliveryMethod, reviseProductsDeliveryMethod };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/utils/reviseUnifySelectInventoryDelivery.js